import React from 'react';
import {connect} from 'react-redux';
import axios from "axios";
import Header from '../../../header';
import GuidedToursListPopup from '../../../popup/components/guided-tours-list-popup';
import SupportDetailsPopup from '../../../popup/components/support-details-popup';
import Content from '../../../content';
import UpgradePage from './components/upgrading-page';
import UpgradePageError from './components/upgrading-page-error';
import {API_ROOT} from "../../../../utils";
import {I18nextProvider} from 'react-i18next';
import i18n from '../../../../../i18n';

class UpgradingTemplate extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            error: false
        }
    }

    componentDidMount(){
        axios.get(API_ROOT + '/api/util/migrate', {withCredentials: true}).then(response => {
            if(response.status === 200){
                window.location.href = window.location.origin;
            } else {
                this.setState({
                    error: true
                })
            }
        }).catch(() => {
            this.setState({
                error: true
            })
        })
    }

	render() {
		return (
			<I18nextProvider i18n={i18n}>
				<div className="app not-ready">
					<Header msgBar={false} licenses={false}/>
                    <GuidedToursListPopup/>
					<SupportDetailsPopup/>
					<Content>
                        {
                            this.state.error ? <UpgradePage/> : <UpgradePageError/>
                        }
					</Content>
				</div>
			</I18nextProvider>
		)
	}
}

const mapStateToProps = state => ({
	language : state.languageReducer.language
});

export default connect(mapStateToProps)(UpgradingTemplate);
